import { useTheme, useMediaQuery } from "@mui/material";

export default function ResponsiveCharts({ children }) {
  const theme = useTheme();

  const isXs = useMediaQuery(theme.breakpoints.only("xs"));
  const isSm = useMediaQuery(theme.breakpoints.only("sm"));
  const isMd = useMediaQuery(theme.breakpoints.only("md"));
  const isLg = useMediaQuery(theme.breakpoints.only("lg"));
  const isXl = useMediaQuery(theme.breakpoints.only("xl"));
  const isVerySmall = useMediaQuery("(max-width:345px)");

  let chartWidth;
  let chartWidthPie;
  let pieProps = {};
  let pieChartPaddingLabel = {};
  let pieChartLabelDirection;
  let pieChartLabelPosition = {};
  let pieChartMargin = {};

  let itemMarkWidthBarChart;

  if (isVerySmall) {
    chartWidthPie = 280;
    chartWidth = 300;

    pieProps = { cx: 50, cy: 120, innerRadius: 20, outerRadius: 70 };
    pieChartLabelDirection = "row";
    pieChartLabelPosition = { vertical: "top", horizontal: "middle" };
    pieChartMargin = { top: 60, left: 100 };
    itemMarkWidthBarChart = 10;
    // console.log("selected width very small");
  } else if (isXs) {
    chartWidth = 350;
    pieProps = { cx: 180, cy: 150, innerRadius: 20, outerRadius: 70 };
    // pieChartPaddingLabel = {firstPie: -55, secondPie: -10};
    pieChartLabelDirection = "row";
    pieChartLabelPosition = { vertical: "top", horizontal: "middle" };

    pieChartMargin = { top: 0, bottom: 0, left: 0, right: 150 };

    itemMarkWidthBarChart = 10;

    //console.log("selected width xs");
  } else if (isSm) {
    chartWidth = 450;
    pieProps = { cx: 220, cy: 120, innerRadius: 20, outerRadius: 70 };
    pieChartPaddingLabel = -15;
    pieChartLabelDirection = "column";
    pieChartLabelPosition = { vertical: "middle", horizontal: "right" };
    itemMarkWidthBarChart = 10;

    //console.log("selected width sm");
  } else if (isMd) {
    chartWidth = 500;
    pieProps = { cx: 250, cy: 120, innerRadius: 40, outerRadius: 90 };
    pieChartPaddingLabel = -15;
    pieChartLabelDirection = "column";
    pieChartLabelPosition = { vertical: "middle", horizontal: "right" };
    itemMarkWidthBarChart = 15;

    // console.log("selected width md");
  } else if (isLg) {
    chartWidth = 400;
    pieProps = { cx: 120, cy: 120, innerRadius: 35, outerRadius: 80 };
    pieChartLabelDirection = "column";
    pieChartLabelPosition = { vertical: "middle", horizontal: "right" };

    itemMarkWidthBarChart = 15;
  } else if (isXl) {
    chartWidth = 460;
    pieProps = { cx: 140, cy: 120, innerRadius: 45, outerRadius: 95 };
    pieChartLabelDirection = "column";
    pieChartLabelPosition = { vertical: "middle", horizontal: "right" };
    itemMarkWidthBarChart = 20;
  } else {
    chartWidth = "100%";
    pieProps = { cx: 285, cy: 120, innerRadius: 60, outerRadius: 120 };
    // console.log("selected width 100%");
  }

  return children({
    chartWidth,
    chartWidthPie,
    isVerySmall,
    pieProps,
    pieChartPaddingLabel,
    pieChartLabelDirection,
    pieChartLabelPosition,
    pieChartMargin,
    itemMarkWidthBarChart
  });
}
